import { render, staticRenderFns } from "./FollowEcharts.vue?vue&type=template&id=518124b8&scoped=true"
import script from "./FollowEcharts.vue?vue&type=script&lang=js"
export * from "./FollowEcharts.vue?vue&type=script&lang=js"
import style0 from "./FollowEcharts.vue?vue&type=style&index=0&id=518124b8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518124b8",
  null
  
)

export default component.exports